// Roles list + CRUD (standalone roles — see Component/Table/CastingRoles.js)
export const GET_CASTING_ROLES = "GET_CASTING_ROLES";
export const GET_CASTING_ROLE = "GET_CASTING_ROLE";
export const INSERT_CASTING_ROLE = "INSERT_CASTING_ROLE";
export const UPDATE_CASTING_ROLE = "UPDATE_CASTING_ROLE";
export const DELETE_CASTING_ROLE = "DELETE_CASTING_ROLE";

// Candidates inside a role
export const GET_CASTING_CANDIDATES = "GET_CASTING_CANDIDATES";
export const INSERT_CASTING_CANDIDATE = "INSERT_CASTING_CANDIDATE";
export const DELETE_CASTING_CANDIDATE = "DELETE_CASTING_CANDIDATE";

// Clears the selected role/candidates when leaving a detail screen
export const CLEAR_CASTING_ROLE = "CLEAR_CASTING_ROLE";
